import { render, staticRenderFns } from "./SideAds.vue?vue&type=template&id=e5069b2e&scoped=true&"
import script from "./SideAds.vue?vue&type=script&lang=js&"
export * from "./SideAds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5069b2e",
  null
  
)

export default component.exports